/*
 * @Descripttion: 整理逻辑,添加备注!!!
 * @version:
 * @Author: Wang
 * @Date: 2021-03-18 16:43:02
 * @LastEditors: ------
 * @LastEditTime: 2021-09-13 14:34:05
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "./utils/flexible";
import { Empty, Pagination, Carousel, CarouselItem } from "element-ui";
import VueLazyLoad from "vue-lazyload";

// 引入字体
import "./assets/Font.css";
import EventBus from "./utils/bus";
Vue.use(EventBus);
Vue.prototype.$EventBus = EventBus;

Vue.config.productionTip = false;

Vue.use(Pagination)
  .use(Empty)
  .use(Carousel)
  .use(CarouselItem)
  .use(VueLazyLoad);

router.beforeEach((to, form, next) => {
  window.document.title = to.meta.title == undefined ? "爱介护" : to.meta.title;
  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js